<template>
  <section class="content">
    <!--<template v-for="alert in alerts">
      <b-alert :show="alert.dismiss" dismissible :variant="alert.type">
        <h4>
          <i v-if="alert.type == 'success' || alert.type == 'warning' "class="icon fa fa-check"></i>
          <i class="icon fa fa-ban" v-else></i>
          {{'alert_'+alert.type | translate}}!</h4>
        {{alert.message}}
        <a v-if="alert.action" class="btn btn-success" @click="alert.action">Go to Details</a>
      </b-alert>
    </template>-->
    <div class="row">
      <div class="col-xs-12">
        <div class="box box-primary">
          <vue-form :state="formstate" v-model="formstate" @submit.prevent="onSubmit">
            <div class="box-header with-border">
              <h3 class="box-title">{{'create_store' | translate}}</h3>
              <div class="box-tools pull-right">
                <button type="button" class="btn btn-box-tool" data-widget="collapse">
                  <i class="fa fa-minus"></i>
                </button>
              </div>
              <div class="box-controls">
                <div class="row">
                  <div class="col-xs-12">
                    <div class="btn-group pt-10 pb-10" data-toggle="btn-toggle">
                      <button type="button" class="btn btn-success"><i class="fa fa-check mr-5"></i>{{'active' | translate}}</button>
                      <button type="button" class="btn btn-danger active"><i class="fa fa-ban mr-5"></i>{{'in_active' | translate}}</button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="box-body">
                <div class="row">
                  <div class="col-sm-6 col-xs-12">
                    <div class="form-group">
                      <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.name, 'name')">
                        <label>{{'name' | translate | capitalize}}</label>
                        <input type="text" name="name" class="form-control" required v-model="store.name">
                      </validate>
                    </div>
                  </div>
                  <div class="col-sm-6 col-xs-12">
                    <div class="form-group">
                      <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.erp_store_id, 'erp_store_id')">
                        <label>{{'erp_store_id' | translate | capitalize}}</label>
                        <input type="text" name="erp_store_id" class="form-control" required v-model="store.erp_store_id">
                      </validate>
                    </div>
                  </div>
                  <div class="col-sm-6 col-xs-12">
                    <div class="form-group">
                      <validate auto-label class="form-group" :class="fieldClassName(formstate.street, 'street')">
                        <label>{{'street' | translate | capitalize}}</label>
                        <input type="text" name="street" class="form-control" v-model="store.street">
                      </validate>
                    </div>
                  </div>
                  <div class="col-sm-6 col-xs-12">
                    <div class="form-group">
                      <validate auto-label class="form-group" :class="fieldClassName(formstate.street_no, 'street_no')">
                        <label>{{'street_no' | translate | capitalize}}</label>
                        <input type="text" name="street_no" class="form-control" v-model="store.street_no">
                      </validate>
                    </div>
                  </div>
                  <div class="col-sm-6 col-xs-12">
                    <div class="form-group">
                      <validate auto-label class="form-group" :class="fieldClassName(formstate.city, 'city')" >
                        <label>{{'city' | translate | capitalize}}</label>
                        <input type="text" name="city" class="form-control" v-model="store.city">
                      </validate>
                    </div>
                  </div>
                  <div class="col-sm-6 col-xs-12">
                    <div class="form-group">
                      <validate auto-label class="form-group" :class="fieldClassName(formstate.zip_code, 'zip_code')">
                        <label>{{'zip_code' | translate | capitalize}}</label>
                        <input type="text" name="zip_code" class="form-control" v-model="store.zip_code">
                      </validate>
                    </div>
                  </div>
                  <div class="col-sm-6 col-xs-12">
                    <div class="form-group">
                      <validate auto-label class="form-group" :class="fieldClassName(formstate.country, 'country')">
                        <label>{{'country' | translate | capitalize}}</label>
                        <select class="form-control" name="country" required v-model="store.country">
                          <option :value="null">{{'choose' | translate}}...</option>
                          <option value="AF">{{'Afghanistan' | translate}}</option>
                          <option value="AX">{{'Åland Islands' | translate}}</option>
                          <option value="AL">{{'Albania' | translate}}</option>
                          <option value="DZ">{{'Algeria' | translate}}</option>
                          <option value="AS">{{'American Samoa' | translate}}</option>
                          <option value="AD">{{'Andorra' | translate}}</option>
                          <option value="AO">{{'Angola' | translate}}</option>
                          <option value="AI">{{'Anguilla' | translate}}</option>
                          <option value="AQ">{{'Antarctica' | translate}}</option>
                          <option value="AG">{{'Antigua and Barbuda' | translate}}</option>
                          <option value="AR">{{'Argentina' | translate}}</option>
                          <option value="AM">{{'Armenia' | translate}}</option>
                          <option value="AW">{{'Aruba' | translate}}</option>
                          <option value="AU">{{'Australia' | translate}}</option>
                          <option value="AT">{{'Austria' | translate}}</option>
                          <option value="AZ">{{'Azerbaijan' | translate}}</option>
                          <option value="BS">{{'Bahamas' | translate}}</option>
                          <option value="BH">{{'Bahrain' | translate}}</option>
                          <option value="BD">{{'Bangladesh' | translate}}</option>
                          <option value="BB">{{'Barbados' | translate}}</option>
                          <option value="BY">{{'Belarus' | translate}}</option>
                          <option value="BE">{{'Belgium' | translate}}</option>
                          <option value="BZ">{{'Belize' | translate}}</option>
                          <option value="BJ">{{'Benin' | translate}}</option>
                          <option value="BM">{{'Bermuda' | translate}}</option>
                          <option value="BT">{{'Bhutan' | translate}}</option>
                          <option value="BO">{{'Bolivia' | translate}}</option>
                          <option value="BA">{{'Bosnia and Herzegovina' | translate}}</option>
                          <option value="BW">{{'Botswana' | translate}}</option>
                          <option value="BV">{{'Bouvet Island' | translate}}</option>
                          <option value="BR">{{'Brazil' | translate}}</option>
                          <option value="IO">{{'British Indian Ocean Territory' | translate}}</option>
                          <option value="BN">{{'Brunei Darussalam' | translate}}</option>
                          <option value="BG">{{'Bulgaria' | translate}}</option>
                          <option value="BF">{{'Burkina Faso' | translate}}</option>
                          <option value="BI">{{'Burundi' | translate}}</option>
                          <option value="KH">{{'Cambodia' | translate}}</option>
                          <option value="CM">{{'Cameroon' | translate}}</option>
                          <option value="CA">{{'Canada' | translate}}</option>
                          <option value="CV">{{'Cape Verde' | translate}}</option>
                          <option value="KY">{{'Cayman Islands' | translate}}</option>
                          <option value="CF">{{'Central African Republic' | translate}}</option>
                          <option value="TD">{{'Chad' | translate}}</option>
                          <option value="CL">{{'Chile' | translate}}</option>
                          <option value="CN">{{'China' | translate}}</option>
                          <option value="CX">{{'Christmas Island' | translate}}</option>
                          <option value="CC">{{'Cocos (Keeling) Islands' | translate}}</option>
                          <option value="CO">{{'Colombia' | translate}}</option>
                          <option value="KM">{{'Comoros' | translate}}</option>
                          <option value="CG">{{'Congo' | translate}}</option>
                          <option value="CD">{{'Congo, the Democratic Republic of the' | translate}}</option>
                          <option value="CK">{{'Cook Islands' | translate}}</option>
                          <option value="CR">{{'Costa Rica' | translate}}</option>
                          <option value="HR">{{'Croatia' | translate}}</option>
                          <option value="CU">{{'Cuba' | translate}}</option>
                          <option value="CW">{{'Curaçao' | translate}}</option>
                          <option value="CY">{{'Cyprus' | translate}}</option>
                          <option value="CZ">{{'Czech Republic' | translate}}</option>
                          <option value="DK">{{'Denmark' | translate}}</option>
                          <option value="DJ">{{'Djibouti' | translate}}</option>
                          <option value="DM">{{'Dominica' | translate}}</option>
                          <option value="DO">{{'Dominican Republic' | translate}}</option>
                          <option value="EC">{{'Ecuador' | translate}}</option>
                          <option value="EG">{{'Egypt' | translate}}</option>
                          <option value="SV">{{'El Salvador' | translate}}</option>
                          <option value="GQ">{{'Equatorial Guinea' | translate}}</option>
                          <option value="ER">{{'Eritrea' | translate}}</option>
                          <option value="EE">{{'Estonia' | translate}}</option>
                          <option value="ET">{{'Ethiopia' | translate}}</option>
                          <option value="FK">{{'Falkland Islands (Malvinas)' | translate}}</option>
                          <option value="FO">{{'Faroe Islands' | translate}}</option>
                          <option value="FJ">{{'Fiji' | translate}}</option>
                          <option value="FI">{{'Finland' | translate}}</option>
                          <option value="FR">{{'France' | translate}}</option>
                          <option value="GF">{{'French Guiana' | translate}}</option>
                          <option value="PF">{{'French Polynesia' | translate}}</option>
                          <option value="TF">{{'French Southern Territories' | translate}}</option>
                          <option value="GA">{{'Gabon' | translate}}</option>
                          <option value="GM">{{'Gambia' | translate}}</option>
                          <option value="GE">{{'Georgia' | translate}}</option>
                          <option value="DE">{{'Germany' | translate}}</option>
                          <option value="GH">{{'Ghana' | translate}}</option>
                          <option value="GI">{{'Gibraltar' | translate}}</option>
                          <option value="GR">{{'Greece' | translate}}</option>
                          <option value="GL">{{'Greenland' | translate}}</option>
                          <option value="GD">{{'Grenada' | translate}}</option>
                          <option value="GP">{{'Guadeloupe' | translate}}</option>
                          <option value="GU">{{'Guam' | translate}}</option>
                          <option value="GT">{{'Guatemala' | translate}}</option>
                          <option value="GG">{{'Guernsey' | translate}}</option>
                          <option value="GN">{{'Guinea' | translate}}</option>
                          <option value="GW">{{'Guinea-Bissau' | translate}}</option>
                          <option value="GY">{{'Guyana' | translate}}</option>
                          <option value="HT">{{'Haiti' | translate}}</option>
                          <option value="HM">{{'Heard Island and McDonald Islands' | translate}}</option>
                          <option value="VA">{{'Holy See (Vatican City State)' | translate}}</option>
                          <option value="HN">{{'Honduras' | translate}}</option>
                          <option value="HK">{{'Hong Kong' | translate}}</option>
                          <option value="HU">{{'Hungary' | translate}}</option>
                          <option value="IS">{{'Iceland' | translate}}</option>
                          <option value="IN">{{'India' | translate}}</option>
                          <option value="ID">{{'Indonesia' | translate}}</option>
                          <option value="IR">{{'Iran, Islamic Republic of' | translate}}</option>
                          <option value="IQ">{{'Iraq' | translate}}</option>
                          <option value="IE">{{'Ireland' | translate}}</option>
                          <option value="IM">{{'Isle of Man' | translate}}</option>
                          <option value="IL">{{'Israel' | translate}}</option>
                          <option value="IT">{{'Italy' | translate}}</option>
                          <option value="CI">{{'Ivory Coast' | translate}}</option>
                          <option value="JM">{{'Jamaica' | translate}}</option>
                          <option value="JP">{{'Japan' | translate}}</option>
                          <option value="JE">{{'Jersey' | translate}}</option>
                          <option value="JO">{{'Jordan' | translate}}</option>
                          <option value="KZ">{{'Kazakhstan' | translate}}</option>
                          <option value="KE">{{'Kenya' | translate}}</option>
                          <option value="KI">{{'Kiribati' | translate}}</option>
                          <option value="KP">{{'North Korea' | translate}}</option>
                          <option value="KR">{{'South Korea' | translate}}</option>
                          <option value="KW">{{'Kuwait' | translate}}</option>
                          <option value="KG">{{'Kyrgyzstan' | translate}}</option>
                          <option value="LA">{{'Laos' | translate}}</option>
                          <option value="LV">{{'Latvia' | translate}}</option>
                          <option value="LB">{{'Lebanon' | translate}}</option>
                          <option value="LS">{{'Lesotho' | translate}}</option>
                          <option value="LR">{{'Liberia' | translate}}</option>
                          <option value="LY">{{'Libya' | translate}}</option>
                          <option value="LI">{{'Liechtenstein' | translate}}</option>
                          <option value="LT">{{'Lithuania' | translate}}</option>
                          <option value="LU">{{'Luxembourg' | translate}}</option>
                          <option value="MO">{{'Macao' | translate}}</option>
                          <option value="MK">{{'Macedonia, the former Yugoslav Republic of' | translate}}</option>
                          <option value="MG">{{'Madagascar' | translate}}</option>
                          <option value="MW">{{'Malawi' | translate}}</option>
                          <option value="MY">{{'Malaysia' | translate}}</option>
                          <option value="MV">{{'Maldives' | translate}}</option>
                          <option value="ML">{{'Mali' | translate}}</option>
                          <option value="MT">{{'Malta' | translate}}</option>
                          <option value="MH">{{'Marshall Islands' | translate}}</option>
                          <option value="MQ">{{'Martinique' | translate}}</option>
                          <option value="MR">{{'Mauritania' | translate}}</option>
                          <option value="MU">{{'Mauritius' | translate}}</option>
                          <option value="YT">{{'Mayotte' | translate}}</option>
                          <option value="MX">{{'Mexico' | translate}}</option>
                          <option value="FM">{{'Micronesia, Federated States of' | translate}}</option>
                          <option value="MD">{{'Moldova, Republic of' | translate}}</option>
                          <option value="MC">{{'Monaco' | translate}}</option>
                          <option value="MN">{{'Mongolia' | translate}}</option>
                          <option value="ME">{{'Montenegro' | translate}}</option>
                          <option value="MS">{{'Montserrat' | translate}}</option>
                          <option value="MA">{{'Morocco' | translate}}</option>
                          <option value="MZ">{{'Mozambique' | translate}}</option>
                          <option value="MM">{{'Myanmar' | translate}}</option>
                          <option value="NA">{{'Namibia' | translate}}</option>
                          <option value="NR">{{'Nauru' | translate}}</option>
                          <option value="NP">{{'Nepal' | translate}}</option>
                          <option value="NL">{{'Netherlands' | translate}}</option>
                          <option value="NC">{{'New Caledonia' | translate}}</option>
                          <option value="NZ">{{'New Zealand' | translate}}</option>
                          <option value="NI">{{'Nicaragua' | translate}}</option>
                          <option value="NE">{{'Niger' | translate}}</option>
                          <option value="NG">{{'Nigeria' | translate}}</option>
                          <option value="NU">{{'Niue' | translate}}</option>
                          <option value="NF">{{'Norfolk Island' | translate}}</option>
                          <option value="MP">{{'Northern Mariana Islands' | translate}}</option>
                          <option value="NO">{{'Norway' | translate}}</option>
                          <option value="OM">{{'Oman' | translate}}</option>
                          <option value="PK">{{'Pakistan' | translate}}</option>
                          <option value="PW">{{'Palau' | translate}}</option>
                          <option value="PS">{{'Palestinian Territory, Occupied' | translate}}</option>
                          <option value="PA">{{'Panama' | translate}}</option>
                          <option value="PG">{{'Papua New Guinea' | translate}}</option>
                          <option value="PY">{{'Paraguay' | translate}}</option>
                          <option value="PE">{{'Peru' | translate}}</option>
                          <option value="PH">{{'Philippines' | translate}}</option>
                          <option value="PN">{{'Pitcairn' | translate}}</option>
                          <option value="PL">{{'Poland' | translate}}</option>
                          <option value="PT">{{'Portugal' | translate}}</option>
                          <option value="PR">{{'Puerto Rico' | translate}}</option>
                          <option value="QA">{{'Qatar' | translate}}</option>
                          <option value="RE">{{'Réunion' | translate}}</option>
                          <option value="RO">{{'Romania' | translate}}</option>
                          <option value="RU">{{'Russian Federation' | translate}}</option>
                          <option value="RW">{{'Rwanda' | translate}}</option>
                          <option value="BL">{{'Saint Barthélemy' | translate}}</option>
                          <option value="SH">{{'Saint Helena, Ascension and Tristan da Cunha' | translate}}</option>
                          <option value="KN">{{'Saint Kitts and Nevis' | translate}}</option>
                          <option value="LC">{{'Saint Lucia' | translate}}</option>
                          <option value="MF">{{'Saint Martin (French part)' | translate}}</option>
                          <option value="PM">{{'Saint Pierre and Miquelon' | translate}}</option>
                          <option value="VC">{{'Saint Vincent and the Grenadines' | translate}}</option>
                          <option value="WS">{{'Samoa' | translate}}</option>
                          <option value="SM">{{'San Marino' | translate}}</option>
                          <option value="ST">{{'Sao Tome and Principe' | translate}}</option>
                          <option value="SA">{{'Saudi Arabia' | translate}}</option>
                          <option value="SN">{{'Senegal' | translate}}</option>
                          <option value="RS">{{'Serbia' | translate}}</option>
                          <option value="SC">{{'Seychelles' | translate}}</option>
                          <option value="SL">{{'Sierra Leone' | translate}}</option>
                          <option value="SG">{{'Singapore' | translate}}</option>
                          <option value="SX">{{'Sint Maarten (Dutch part)' | translate}}</option>
                          <option value="SK">{{'Slovakia' | translate}}</option>
                          <option value="SI">{{'Slovenia' | translate}}</option>
                          <option value="SB">{{'Solomon Islands' | translate}}</option>
                          <option value="SO">{{'Somalia' | translate}}</option>
                          <option value="ZA">{{'South Africa' | translate}}</option>
                          <option value="GS">{{'South Georgia and the South Sandwich Islands' | translate}}</option>
                          <option value="SS">{{'South Sudan' | translate}}</option>
                          <option value="ES">{{'Spain' | translate}}</option>
                          <option value="LK">{{'Sri Lanka' | translate}}</option>
                          <option value="SD">{{'Sudan' | translate}}</option>
                          <option value="SR">{{'Suriname' | translate}}</option>
                          <option value="SJ">{{'Svalbard and Jan Mayen' | translate}}</option>
                          <option value="SZ">{{'Swaziland' | translate}}</option>
                          <option value="SE">{{'Sweden' | translate}}</option>
                          <option value="CH">{{'Switzerland' | translate}}</option>
                          <option value="SY">{{'Syrian Arab Republic' | translate}}</option>
                          <option value="TW">{{'Taiwan, Province of China' | translate}}</option>
                          <option value="TJ">{{'Tajikistan' | translate}}</option>
                          <option value="TZ">{{'Tanzania, United Republic of' | translate}}</option>
                          <option value="TH">{{'Thailand' | translate}}</option>
                          <option value="TL">{{'Timor-Leste' | translate}}</option>
                          <option value="TG">{{'Togo' | translate}}</option>
                          <option value="TK">{{'Tokelau' | translate}}</option>
                          <option value="TO">{{'Tonga' | translate}}</option>
                          <option value="TT">{{'Trinidad and Tobago' | translate}}</option>
                          <option value="TN">{{'Tunisia' | translate}}</option>
                          <option value="TR">{{'Turkey' | translate}}</option>
                          <option value="TM">{{'Turkmenistan' | translate}}</option>
                          <option value="TC">{{'Turks and Caicos Islands' | translate}}</option>
                          <option value="TV">{{'Tuvalu' | translate}}</option>
                          <option value="UG">{{'Uganda' | translate}}</option>
                          <option value="UA">{{'Ukraine' | translate}}</option>
                          <option value="AE">{{'United Arab Emirates' | translate}}</option>
                          <option value="GB">{{'United Kingdom' | translate}}</option>
                          <option value="US">{{'United States' | translate}}</option>
                          <option value="UM">{{'United States Minor Outlying Islands' | translate}}</option>
                          <option value="UY">{{'Uruguay' | translate}}</option>
                          <option value="UZ">{{'Uzbekistan' | translate}}</option>
                          <option value="VU">{{'Vanuatu' | translate}}</option>
                          <option value="VE">{{'Venezuela, Bolivarian Republic of' | translate}}</option>
                          <option value="VN">{{'Viet Nam' | translate}}</option>
                          <option value="VG">{{'Virgin Islands, British' | translate}}</option>
                          <option value="VI">{{'Virgin Islands, U.S.' | translate}}</option>
                          <option value="WF">{{'Wallis and Futuna' | translate}}</option>
                          <option value="EH">{{'Western Sahara' | translate}}</option>
                          <option value="YE">{{'Yemen' | translate}}</option>
                          <option value="ZM">{{'Zambia' | translate}}</option>
                          <option value="ZW">{{'Zimbabwe' | translate}}</option>
                        </select>
                      </validate>
                    </div>
                  </div>
                  <div class="col-sm-6 col-xs-12">
                    <div class="form-group">
                      <validate auto-label class="form-group" :class="fieldClassName(formstate.contact_phone, 'contact_phone')">
                        <label>{{'contact_phone' | translate | capitalize}}</label>
                        <input type="text" name="contact_phone" class="form-control" v-model="store.contact_phone">
                      </validate>
                    </div>
                  </div>
                  <div class="col-sm-6 col-xs-12">
                    <div class="form-group">
                      <validate auto-label class="form-group" :class="fieldClassName(formstate.contact_name, 'contact_name')">
                        <label>{{'contact_name' | translate | capitalize}}</label>
                        <input type="text" name="contact_name" class="form-control" v-model="store.contact_name">
                      </validate>
                    </div>
                  </div>
                  <div class="col-sm-6 col-xs-12">
                    <div class="form-group">
                      <validate auto-label class="form-group" :class="fieldClassName(formstate.contact_email, 'contact_email')">
                        <label>{{'contact_email' | translate | capitalize}}</label>
                        <input type="text" name="contact_email" class="form-control" v-model="store.contact_email">
                      </validate>
                    </div>
                  </div>
                  <div class="col-sm-6 col-xs-12">
                    <div class="form-group">
                      <validate auto-label class="form-group" :class="fieldClassName(formstate.order_email, 'order_email')">
                        <label>{{'order_email' | translate | capitalize}}</label>
                        <input type="text" name="order_email" class="form-control" v-model="store.order_email">
                      </validate>
                    </div>
                  </div>
                  <div class="col-sm-6 col-xs-12">
                    <div class="form-group">
                      <validate auto-label class="form-group" :class="fieldClassName(formstate.shipping_name, 'shipping_name')">
                        <label>{{'shipping_name' | translate | capitalize}}</label>
                        <input type="text" name="shipping_name" class="form-control" v-model="store.shipping_name">
                      </validate>
                    </div>
                  </div>
                  <div class="col-sm-6 col-xs-12">
                    <div class="form-group">
                      <validate auto-label class="form-group" :class="fieldClassName(formstate.shipping_street, 'shipping_street')">
                        <label>{{'shipping_street' | translate | capitalize}}</label>
                        <input type="text" name="shipping_street" class="form-control" v-model="store.shipping_street">
                      </validate>
                    </div>
                  </div>
                  <div class="col-sm-6 col-xs-12">
                    <div class="form-group">
                      <validate auto-label class="form-group" :class="fieldClassName(formstate.shipping_street_no, 'shipping_street_no')">
                        <label>{{'shipping_street_no' | translate | capitalize}}</label>
                        <input type="text" name="shipping_street_no" class="form-control" v-model="store.shipping_street_no">
                      </validate>
                    </div>
                  </div>
                  <div class="col-sm-6 col-xs-12">
                    <div class="form-group">
                      <validate auto-label class="form-group" :class="fieldClassName(formstate.shipping_city, 'shipping_city')">
                        <label>{{'shipping_city' | translate | capitalize}}</label>
                        <input type="text" name="shipping_city" class="form-control" v-model="store.shipping_city">
                      </validate>
                    </div>
                  </div>
                  <div class="col-sm-6 col-xs-12">
                    <div class="form-group">
                      <validate auto-label class="form-group" :class="fieldClassName(formstate.shipping_zip_code, 'shipping_zip_code')">
                        <label>{{'shipping_zip_code' | translate | capitalize}}</label>
                        <input type="text" name="shipping_zip_code" class="form-control" v-model="store.shipping_zip_code">
                      </validate>
                    </div>
                  </div>
                  <div class="col-sm-6 col-xs-12">
                    <div class="form-group">
                      <validate auto-label class="form-group" :class="fieldClassName(formstate.shipping_country, 'shipping_country')">
                        <label>{{'shipping_country' | translate | capitalize}}</label>
                        <input type="text" name="shipping_country" class="form-control" v-model="store.shipping_country">
                      </validate>
                    </div>
                  </div>
                </div>
                <hr>
                <div class="row">
                  <div class="col-xs-6"></div>
                  <div class="col-xs-6 text-right">
                    <button class="btn btn-app btn-success" type="submit"><i class="fa fa-save mr-5"></i>{{'create_store' | translate}}</button>
                  </div>
                </div>
              </div>
            </div>
          </vue-form>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
  require('moment')
  export default {
    data () {
      return {
        formstate: {},
        store: {
          name: '',
          erp_store_id: '',
          street: '',
          street_no: '',
          city: '',
          zip_code: '',
          country: 'DE',
          contact_phone: '',
          contact_name: '',
          contact_email: '',
          order_email: '',
          shipping_name: '',
          shipping_street: '',
          shipping_street_no: '',
          shipping_city: '',
          shipping_zip_code: '',
          shipping_country: '',
          is_active: true
        },
        translate: this.$parent.translate,
        disabled: true,
        serverURI: this.$parent.serverURI + 'accounting/stores',
        caller: this.$http,
        alerts: [],
        storeData: {},
        checkToken () {
          return window.localStorage.getItem('token') == null ? '' : window.localStorage.getItem('token')
        },
        sendData (data) {
          /*return this.caller.post(
            this.serverURI, data,
            {
              headers: {
                'Content-Type': 'application/json',
                'auth-token': this.checkToken()
              }
            }
          )*/
          API.post('accounting/stores', data)
            .then(response => {
              let alert = { dismiss: 4, type: 'success', message: 'Store created successfully', action: this.redirect(response.body.success) }
              this.$store.commit('pushAlert', alert)
            })
            .catch(error => {
              if (this.$store.dispatch('checkError', error)) {
                let alert = {dismiss: 99, type: 'danger', message: this.translate(error.body.error_code) || error.body.error_message}
                this.$store.commit('pushAlert', alert)
              }
            })
        }
      }
    },
    computed: {
    },
    methods: {
      fieldClassName (field, key) {
        if (!field) {
          return ''
        }
        if ((field.$touched || field.$submitted) && field.$valid && !field.$pristine && this.store[key] !== '') {
          return 'has-success'
        }
        if ((field.$touched || field.$submitted) && field.$invalid) {
          return 'has-error'
        }
      },
      onSubmit () {
        this.postData()
      },
      postData () {
        let data = {}
        for (let x in this.storeData) {
          data[x] = this.storeData[x].value
        }
        this.sendData(this.store)
      },
      redirect (id) {
        this.$router.push(`/accounting/stores/${id}`)
      }
    },
    mounted () {
    }
  }
</script>

<style>
  .required-field > label::after {
    content: '*';
    color: white;
    margin-left: 0.25rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/views/Accounting/StoreCreate.vue